import { render, staticRenderFns } from "./SendBatchToOdooModal.vue?vue&type=template&id=365d60e7&scoped=true&"
import script from "./SendBatchToOdooModal.vue?vue&type=script&lang=js&"
export * from "./SendBatchToOdooModal.vue?vue&type=script&lang=js&"
import style0 from "./SendBatchToOdooModal.vue?vue&type=style&index=0&id=365d60e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d60e7",
  null
  
)

export default component.exports